import React from 'react';
import { Modal as MuiModal, Box, Backdrop } from '@mui/material';

const Modal = ({
  open,
  onClose,
  children,
  width = '55%',  // Default width that can be overridden
  maxWidth = 1000, // Default max-width that can be overridden
  height = '85%',  // Default height that can be overridden
  top = '5%',      // Default top position that can be overridden
  borderRadius = 8, // Default border radius matching team project modals
}) => {
  return (
    <MuiModal
      open={open}
      onClose={onClose}
      disableScrollLock
      BackdropComponent={Backdrop}
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(8px)',
          bgcolor: 'rgba(245, 245, 245, 0.7)',
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: width,
          maxWidth: maxWidth,
          height: height === 'auto' ? 'auto' : height,
          bgcolor: 'background.paper',
          borderRadius: borderRadius,
          boxShadow: 24,
          overflowY: height === 'auto' ? 'visible' : 'auto',
          p: 3,
          outline: 'none',
        }}
      >
        {children}
      </Box>
    </MuiModal>
  );
};

export default Modal;